export const waterfallSaleAssets = {
	greenArrow: "/spec_waterfall_sale/green_arrow.png",
	plusIcon: "/spec_waterfall_sale/plus_icon.png",
	checkIcon: "/spec_waterfall_sale/check_icon.svg",
	chain: "/spec_waterfall_sale/chain_v3.png"
} as const;
